
 /**
 * defa.views.SubscriptionReplaceChoiceForm
 * A view for deciding which replace flow to use.
 * @version 1.3.0
 */
import Form           from 'scripts/poppet/form';
import template       from 'templates/subscriptionReplacChoiceForm.jst.html';


const selectors = {
	template: template,
	buttons : '[data-input=replace-option-radio]',
};

const SubscriptionReplaceChoiceForm = Form.extend({
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: selectors.template,
	
	ui: {
		buttons: selectors.buttons,
	},
	
	templateContext: function() {
		return {
			isTechSupport : this.options.isTechSupport,
			hasAlarmGroup : this.options.hasAlarmGroup,
		};
	},
	
		
		// ------------------------------------------------
		// Event Handlers
		// ------------------------------------------------
		
		
		
		// ------------------------------------------------
		// Other functions
		// ------------------------------------------------
		
		/**
		 * Submits the form
		 * @void
		 */
	submit: function() {
		this.trigger( 'replace:choice', this.ui.buttons.filter( ':checked' ).val().trim() );
	},
		
});

	 export default SubscriptionReplaceChoiceForm;